module.exports = __webpack_public_path__ + "static/6013-San-Bernard-Plan-c41e038b724e563262d9e0e9de7bc96a.jpg";